import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { FileDeliveryNavigation, ErrorBanner, RequireServiceAccount } from './components';
import { FileDeliveryProvider } from './contexts';
import {
  ServiceAccounts,
  ServiceAccountsListView,
  ServiceAccountView,
} from '@admin-ui-root/src/app/pages/FileDelivery/components/ServiceAccounts';
import {
  Deliveries,
  DeliveriesListView,
  DeliveryView,
} from '@admin-ui-root/src/app/pages/FileDelivery/components/Deliveries';
import {
  Locations,
  LocationsListView,
  LocationView,
  LocationForm,
} from '@admin-ui-root/src/app/pages/FileDelivery/components/Locations';
import {
  Schedules,
  SchedulesListView,
  ScheduleView,
  ScheduleForm,
} from '@admin-ui-root/src/app/pages/FileDelivery/components/Schedules';
import {
  Credentials,
  CredentialsListView,
  CredentialView,
  CredentialForm,
} from '@admin-ui-root/src/app/pages/FileDelivery/components/Credentials';

export const FileDeliveryRouter: React.FC = () => {
  return (
    <FileDeliveryProvider>
      <FileDeliveryNavigation />
      <ErrorBanner />
      <Routes>
        <Route index element={<Navigate to="deliveries" replace />} />
        <Route
          path="deliveries"
          element={
            <RequireServiceAccount>
              <Deliveries />
            </RequireServiceAccount>
          }
        >
          <Route index element={<DeliveriesListView />} />
          <Route path=":deliveryName" element={<DeliveryView />} />
        </Route>
        <Route
          path="locations"
          element={
            <RequireServiceAccount>
              <Locations />
            </RequireServiceAccount>
          }
        >
          <Route index element={<LocationsListView />} />
          <Route path=":locationUid" element={<LocationView />} />
          <Route path=":locationUid/edit" element={<LocationForm />} />
        </Route>
        <Route
          path="credentials"
          element={
            <RequireServiceAccount>
              <Credentials />
            </RequireServiceAccount>
          }
        >
          <Route index element={<CredentialsListView />} />
          <Route path=":credentialUid" element={<CredentialView />} />
          <Route path=":credentialUid/edit" element={<CredentialForm />} />
        </Route>
        <Route
          path="scheduledDeliveries"
          element={
            <RequireServiceAccount>
              <Schedules />
            </RequireServiceAccount>
          }
        >
          <Route index element={<SchedulesListView />} />
          <Route path=":scheduleUid" element={<ScheduleView />} />
          <Route path=":scheduleUid/edit" element={<ScheduleForm />} />
        </Route>
        <Route path="serviceAccounts" element={<ServiceAccounts />}>
          <Route index element={<ServiceAccountsListView />} />
          <Route path=":accountUuid" element={<ServiceAccountView />} />
        </Route>
      </Routes>
    </FileDeliveryProvider>
  );
};
